import { matchPath, useLocation } from 'react-router'
import cookies from 'js-cookie'
import { REFERRER_KEY, getItemSafe } from '../helpers/localStorage'

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateEmail(str: string) {
  return emailPattern.test(str)
}

function normalize(src: string) {
  return src
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // source: https://stackoverflow.com/a/37511463
    .toLowerCase()
    .replace(/\s/g, '')
    .replace(/[^a-zA-Z0-9]/g, '-')
}

export function formatUsername(username: string) {
  return normalize(username).slice(0, 63)
}

export function formatName(name: string) {
  // No white spaces, all symbols are replaced by '-', and max length of 63
  return name
    .replace(/\s/g, '')
    .replace(/[^a-zA-Z0-9]/g, '-')
    .slice(0, 63)
}

export function displayNameToUsername(displayName: string) {
  return formatUsername(displayName.split(' ')[0])
}

export function isDesktop() {
  return 'electron' in window
}

export function isAskXDesktop() {
  return 'todesktop' in window
}

export function sleeper(ms: number) {
  return function sleep(x: unknown) {
    return new Promise((resolve) => setTimeout(() => resolve(x), ms))
  }
}

export const getOrgCreationFlow = (appPath: string): string | null => {
  // This happens when a owners signs up coming from slite.com/templates/*
  const websiteTemplatePath = matchPath(appPath, '/app/importNote/:noteId')

  if (websiteTemplatePath?.isExact) {
    return 'website-templates'
  }

  return null
}

export const getStructureCacheKeyFromUrl = (): string | undefined => {
  const parsedUrl = new URL(window.location.href)
  return parsedUrl.searchParams.get('structureCacheKey') ?? undefined
}

export const getDocCacheKeyFromUrl = (): string | undefined => {
  const parsedUrl = new URL(window.location.href)
  return parsedUrl.searchParams.get('docCacheKey') ?? undefined
}

export function getReferrer() {
  const referrer = getItemSafe(REFERRER_KEY)
  return !referrer ? undefined : referrer
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getUserFirstAttribution(): Record<any, any> {
  const firstAttribution = cookies.get('SLITE_VISITOR_ORIGIN')
  return !firstAttribution ? {} : JSON.parse(firstAttribution)
}

export function useIsSuperEnabledFromUrl() {
  const { pathname } = useLocation()
  return pathname.startsWith('/organization/super')
}
